/**
 * @auth 赖传峰
 * @date 2022/9/9
 */
import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

// NOTICE 因为安卓的 faq 哈希硬编码，所以临时将 #ee85d9d8 重定向
// 'faq-q-25': 通过 Google Play 安装 PikPak，但是在App内购买会员时遇到障碍怎么办？
export default defineNuxtRouteMiddleware(to => {
  if (import.meta.server) return
  const map = {
    '#37b86be5': '#1',
    '#c4c4bd6a': '#2',
    '#bdc9d432': '#3',
    '#cec8d30c': '#4',
    '#d45d2a5a': '#5',
    '#fa0d7115': '#6',
    '#4deed918': '#7',
    '#46e28ee8': '#8',
    '#e4823c3a': '#9',
    '#1569229a': '#10',
    '#66a407eb': '#11',
    '#d832304d': '#12',
    '#ffde21cf': '#13',
    '#a40d3138': '#14',
    '#a7754974': '#15',
    '#6b3ef871': '#16',
    '#868db99c': '#17',
    '#aa34b77f': '#18',
    '#6c117f4b': '#19',
    '#f6cbc6d0': '#20',
    '#3a447113': '#21',
    '#e69d9918': '#22',
    '#e952a273': '#23',
    '#1929195e': '#24',
    '#f58c3934': '#25',
    '#ee85d9d8': '#25',
    '#c9c730dc': '#26',
    '#9f3ba705': '#27',
    '#d27b3e00': '#28',
    '#224619c2': '#29',
  }

  // @ts-ignore
  const target = map[to.hash]
  if (target) return navigateTo({ hash: target })
})
